import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { whistleBlowSystemUserCode } from "ui/Scripts/source/models/consts";
import { Translations } from "ui/Scripts/source/models/translations";
import { IWhistleBlowEventLogListItem } from "ui/Scripts/source/models/whistleBlow/whistleBlowEventLogListItem";
import { AppUtils } from "../../../framework/appUtils";
import { infiniteListPageSize } from "../../../models/common/webConsts";
import * as whistleBlowService from "../../../models/services/whistleBlowService";
import { ActionContainer } from "../../framework/ActionContainer";
import { List } from "../../framework/List/List";
import { ListSearchFilter } from "../../framework/List/ListSearchFilter";
import { VerticalContainer } from "ui/Scripts/source/components/framework/VerticalContainer";

export interface IWhistleBlowEditDialogLogListProp {
    whistleBlowId: string;
}

interface IWhistleBlowEditDialogLogListState {
    // List
    intialized: boolean;
    isLoading: boolean;
    pageSize: number;
    page: number;
    hasMore: boolean;
    filter: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    items: IWhistleBlowEventLogListItem[];
    selectedId: string;
}

export class WhistleBlowEditDialogLogList extends React.Component<IWhistleBlowEditDialogLogListProp, IWhistleBlowEditDialogLogListState> {
    constructor(props: IWhistleBlowEditDialogLogListProp) {
        super(props);
        this.state = {
            intialized: false,
            isLoading: false,
            page: 1,
            hasMore: true,
            filter: "",
            pageSize: infiniteListPageSize,
            sortColumn: "modifyDate",
            sortOrderIsAsc: false,
            items: [],
            selectedId: null,
        };
    }

    searchItems = async (pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean, resetItems: boolean, refreshList: boolean, moveNext: boolean = false) => {
        this.setState({ isLoading: true });
        const result = await AppUtils.callService(() => whistleBlowService.getWhistleBlowEventLogListItems(this.props.whistleBlowId, !refreshList ? pageSize : (page * pageSize), !refreshList ? page : 1, filter, sortColumn, sortOrderIsAsc), false, false, () => this.setState({ isLoading: false }));
        if (!result) return;
        const state = this.state;
        const items = List.getListItems(state.items, state.selectedId, [], result.items, resetItems, refreshList);
        let selectedId = items.selectedId;
        let index = items.items.findIndex(i => i.id === selectedId);
        let detailsItem = index > -1 ? items.items[index] : null;
        if (moveNext && detailsItem && index < items.items.length - 1) {
            index = index + 1;
            detailsItem = items.items[index];
            selectedId = items.items[index].id;
        }
        this.setState({
            intialized: true,
            isLoading: false,
            page: !refreshList ? result.page : page,
            hasMore: result.hasMore,
            filter,
            sortColumn,
            sortOrderIsAsc,
            items: items.items,
            selectedId,
        });
    };

    refreshList = async () => {
        const state = this.state;
        await this.searchItems(state.pageSize, state.page, state.filter, state.sortColumn, state.sortOrderIsAsc, false, true, false);
    };

    componentDidMount(): void {
        const state = this.state;
        this.searchItems(state.pageSize, state.page, state.filter, state.sortColumn, state.sortOrderIsAsc, false, false);
    }

    componentDidUpdate(prevProps: Readonly<IWhistleBlowEditDialogLogListProp>, _prevState: Readonly<IWhistleBlowEditDialogLogListState>): void {
        const state = this.state;
        const props = this.props;

        if (prevProps.whistleBlowId !== props.whistleBlowId) {
            this.searchItems(state.pageSize, state.page, state.filter, state.sortColumn, state.sortOrderIsAsc, true, false);
        }
    }

    changeFilter = (filter: string) => {
        const state = this.state;
        this.searchItems(state.pageSize, 1, filter, state.sortColumn, state.sortOrderIsAsc, true, false);
    };

    handleSearchLines = (sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {
        const state = this.state;
        this.searchItems(state.pageSize, !nextPage ? 1 : state.page + 1, state.filter, sortColumn, sortOrderIsAsc, !nextPage, false);
    };

    handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        this.setState({
            selectedId
        });
    };

    render() {
        const state = this.state;
        return (
            <VerticalContainer
                width="100%"
                before={<ActionContainer
                    leftItems={
                        <ListSearchFilter
                            searchFilter={state.filter}
                            onSearchClick={this.changeFilter}
                        />
                    }
                />}
                main={
                    <List
                        intialized={state.intialized}
                        isLoading={state.isLoading}
                        hasMore={state.hasMore}
                        height="100%"
                        header={{
                            columns: [
                                { size: 2, column: "modifyDate", content: Translations.Time },
                                { size: 2, column: "eventType", content: Translations.AType },
                                { size: 6, column: "description", content: Translations.Modification },
                                { size: 2, column: "modifyUserCode", content: Translations.ModifiedBy }
                            ]
                        }}
                        lines={state.items.map((item) => {
                            return {
                                columns: [
                                    { size: 2, content: Base.timeToDateTimeStr(item.modifyUser.date) },
                                    { size: 2, content: item.eventTypeStr },
                                    { size: 6, content: item.description },
                                    { size: 2, content: item.modifyUser.code === whistleBlowSystemUserCode ? Translations.WhistleBlowInformant : item.modifyUser.name },
                                ],
                                id: item.id
                            };
                        })}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        selectedId={state.selectedId}
                        onSetSelectedIds={this.handleSetSelectedIds}
                        onSearchLines={this.handleSearchLines}
                    />
                }
            />
        );
    }
}